;(function () {
  angular
    .module('contrast.filters')
    .filter('locUnit', function (metricService) {
      'ngInject'

      return metricService.getLocUnit
    })
})()
